module.exports = __webpack_public_path__ + "roboto-bolditalic-webfont.e765f89bde46855d1a92.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-bolditalic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-bolditalic-webfont.woff
// module chunks = styles